import { Component, Input, Output, EventEmitter, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NavController, NavParams, AlertController, Events, ToastController } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
@Component({
  selector: 'page-breadcrumbs',
  templateUrl: 'breadcrumbs.html',
})
export class BreadcrumbsPage {
  Search_box: string = "";
  Save: boolean = false;
  new_folder: any;
  templateName: any;
  template: any;
  templateSelect: boolean = false;
  public show: boolean = false;
  @Output() g_passShowTempList = new EventEmitter();
  @Output() showTemplateStatus = new EventEmitter();
  @Input() pageFlag: number;
  @Input() currentFolder: any;
  new_Json: any;
  allTemplates: any;
  arrBreadCrumbs: [{}];
  filterData: any = [];
  tempName: any;
  flag: boolean = false;
  newTemplate: any;
  pageName: any;
  folderName: any;
  creatFile: any;
  inlineEditAccess: any;
  selectedTemplate: any;
  isenabled: boolean = true;
  value: string = "inherit";
  screenWidth: any;
  col_width: any;
  back_btn_disabledStatus: boolean = false;
  contextIndex = 0;
  broadcastSubs: any;
  constructor(public communicationServ:CommunicationServiceProvider,public navCtrl: NavController, private cdr: ChangeDetectorRef, public navParams: NavParams, private alertCtrl: AlertController, public driveService: DriveServiceProvider, public events: Events, public toastController: ToastController,public configApiService: ConfigApiServiceProvider) {

    var auth = localStorage.getItem('title');
    if (auth == "Shared") {
      this.value = "none";
    } else {
      this.value = "inherit"
    }
  }

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    if (window.innerWidth > 700) {
      this.col_width = 2;
      this.value = "inherit"
    } else {
      this.col_width = 1;
    }
    if (!this.driveService.objRootFolder.name) {
      this.value = "none"
    }
  }

  ngAfterViewInit() {
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if (data.src === "drive") {
        if (data.event === 'currentFolder') {
          let objCurrentFolder = data['currentFolder'];
          if(!objCurrentFolder.name){
            this.value="none"
          }else{
            this.value="inherit"
          }
        }
      }
    })
  }
  
  ngAfterContentChecked() {
    setTimeout(() => {
      if (this.driveService.objBreadCrumbs.length < 2) {
        this.back_btn_disabledStatus = true;
      } else {
        this.back_btn_disabledStatus = false;
      }
    }, 100);
    this.cdr.detectChanges();
  }
  /* * * * * * * *
   * load stored templates data
   * * * * * * * * */
  getCurrentFolderStoredTemplates() {
    let arrTemplateProps = [];
    if (this.driveService.objCurrentFolder.template.length) { // changing the validation to 1 from >1
      for (let idx = 0; idx < this.driveService.objCurrentFolder.template.length; idx++) {
        if (this.driveService.objCurrentFolder.template[idx].id) {
          arrTemplateProps.push(this.driveService.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[idx].id]);
        }
      }
    }
    return arrTemplateProps;
  }

  listTemplates(e) {
    this.filterData = [];
    let arrTemplates = this.getCurrentFolderStoredTemplates();
    if (arrTemplates.length) {
      this.filterData.push(arrTemplates);
    }

    if (this.templateSelect == false) {
      this.show = !this.show;
    } else {
      this.show = false;
    }
  }

  getchildrenTemplate(folder) {
    let childFolderTemplateList = [];
    for (let findex = 0; findex < folder.length; findex++) {
      for (var i = 0; i < this.filterData.length; i++) {
        if (this.filterData[i][0]["templateName"] != folder[findex].template[0].templateName) {
          if (folder[findex].template[0].templateName != "") {
            childFolderTemplateList.push(folder[findex].template)
          }
        }
      }
    }
    return childFolderTemplateList;
  }

  AddFolder() {
    let ProgressCancelClicked = false;
    let alert = this.alertCtrl.create({
      title: 'New Folder',
      inputs: [
        {
          name: 'FolderName',
          placeholder: 'Folder Name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            ProgressCancelClicked = true;
          }
        },
        {
          text: 'Create',
          handler: data => {
            if (data["FolderName"].trim() == "") {
              const toast = this.toastController.create({
                message: 'Folder Name Cannot be Empty!',
                duration: this.configApiService.toastDuration,
              });
              toast.present();
              this.AddFolder();
            } else {
              let foldername: any = this.driveService.objCurrentFolder["folders"].find(item => item.name == data.FolderName);
              if (foldername) {
                const toast = this.toastController.create({
                  message: 'Folder Name already exists. Please, create new foldername',
                  duration: this.configApiService.toastDuration
                });
                toast.present();
                this.AddFolder();
              } else {
                ProgressCancelClicked = false;
                this.driveService.createFolder(data.FolderName);
                this.driveService.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: true });
              }
            }
          }
        }
      ]
    });
    alert.present();
    this.driveService.broadcastInfo({ src: 'drive-main', event: 'showProgressStatus', status: true });
    let events = this.events;
    alert.onDidDismiss(function () {
      if (ProgressCancelClicked == true) {
        this.driveService.broadcastInfo({ src: 'drive-main', event: 'showProgressStatus', status: false });
      }
    });
  }
  newFolderDataCbck = (data) => {
  }

  gotoFolder(folderid) {
    this.driveService.folderSearch ='';
    this.driveService.CurrentFilesData = [];
    this.driveService.objBckupObjFolerProperties = {};
    this.driveService.gotoBreadCrumbsFolder(folderid);
    if (this.pageFlag == 1) {
    } else {
      this.driveService.broadcastInfo({ src: 'drive-main', event: 'showTemplateStatus', status: false });
      this.driveService.broadcastInfo({ src: 'main', event: 'showListView', data: true });
    }
  }


  @ViewChild("insideElement", { static: true }) insideElement;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (targetElement.classList[this.contextIndex] != "more_contextmenu") {
      this.driveService.broadcastInfo({ src: 'breadCrumbs', event: 'openFolderProperties', status: false });
    }
    const clickedInside = this.insideElement.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.show = false;
    }
  }

  openTemplate(item) {
    let currentFolderTemplates = this.getCurrentFolderStoredTemplates();
    this.inlineEditAccess = currentFolderTemplates[0].colprops.find(col => col.editable == true);
    if (this.inlineEditAccess) {
      this.driveService.broadcastInfo({ src: 'grid-main', event: 'ediableGrid', data: this.inlineEditAccess });
    } else {
      this.driveService.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: true });
      let paramKeyVal: any = {};
      paramKeyVal[item[0].sourceKey] = '0';

      if (item.length > 1) {
        setTimeout(() => {
          this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'newdata',item:item,param:paramKeyVal });
        }, 1000)
      } else {
        setTimeout(() => {
          this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'newdata',item:item,param:paramKeyVal });
        }, 1000)
      }
    }
  }

  gotoback(folders) {
    let bcArrLen = folders.length - 2;
    let bThisFolder = (folders[bcArrLen].id);
    this.gotoFolder(bThisFolder);
  }

  openContextMenu() {
    this.driveService.broadcastInfo({ src: 'breadCrumbs', event: 'openFolderProperties', status: true });
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/breadcrumbs/breadcrumbs.ts